/**
 * React Query mutation for AI sender ID generation
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMutation } from '@tanstack/react-query';

import api from '@/services/api';

import type { GenerateSendersPayload, GenerateSendersResponse } from '../types/campaign-texts.types';

const SINGLE_SENDER_GENERATE_TIMEOUT_MS = 180_000;

export function useGenerateSenders() {
  return useMutation<GenerateSendersResponse, Error, GenerateSendersPayload>({
    mutationFn: (payload) =>
      api
        .post('/campaign-texts/generate-senders', payload, { timeout: SINGLE_SENDER_GENERATE_TIMEOUT_MS })
        .then((r) => r.data.data),
  });
}
